import React, { useState } from 'react';
import { Alert, IconButton, LinearProgress } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import { useDispatch, useSelector } from 'react-redux';
import { useEffectAsync } from './reactHelper';
import { sessionActions } from './store';
import useAuth from 'app/hooks/useAuth';

const ServerProvider = ({
  children,
}) => {
  const dispatch = useDispatch();

  // const initialized = useSelector((state) => !!state.session.server);
  const [error, setError] = useState(null);
  // const { user } = useAuth()

  useEffectAsync(async () => {
    if (!error) {
      try {
        const response = await fetch(`${process.env.REACT_APP_TRACCAR_API}/api/server` ,{
          credentials: 'include',
      });
        if (response.ok) {
          dispatch(sessionActions.updateServer(await response.json()));
        } else {
          throw Error(await response.text());
        }
      } catch (error) {
        setError(error.message);
      }
    }
  }, [error]);

  if (error) {
    return (
      <Alert
        severity="error"
        action={(
          <IconButton color="inherit" size="small" onClick={() => setError(null)}>
            <ReplayIcon fontSize="inherit" />
          </IconButton>
        )}
      >
        {error}
      </Alert>
    );
  }
  return children;
};

export default ServerProvider;
